import React from 'react'
import { connect } from 'react-redux'
import Component from '../common/Component'
import fieldGroups, { benefitLabels, metadatumFieldsDiffSet } from './accidentFields'
import publishingActions from '../../actions/BenefitsSetsExportPublishings'
import BenefitsSetExportShow from '../BenefitsSet/BenefitsSetExportShow'

export class AccidentBenefitsSetExportShow extends Component {
  static defaultFields = [
    'id',
    'vericred_id',
    'approval_state',
    'publish_state',
    'name',
    'voluntary',
    'portability',
    'twenty_four_hour',
    'source',
    'issuer_identifier',
    'issuer_name',
    'plan_years',
    'rate_guarantee',
    'accidental_death_dismemberment_included',
    'accidental_death_benefit_employee',
    'accidental_death_benefit_spouse',
    'accidental_death_benefit_child',
    'common_carrier_death_benefit_employee',
    'common_carrier_death_benefit_spouse',
    'common_carrier_death_benefit_child',
    'wellness',
    'ambulance',
    'burns',
    'diagnostic_exam',
    'dislocations',
    'emergency_room_treatment',
    'eye_injury',
    'fractures',
    'hospital_admission',
    'hospital_confinement',
    'hospital_admission_icu',
    'hospital_confinement_icu',
    'treatment_follow_up',
    'treatment_doctors_office_initial',
    'treatment_urgent_care_initial',
    'outpatient_therapy'
  ]

  render() {
    return (
      <BenefitsSetExportShow
        productLine="Accident"
        benefitLabels={benefitLabels}
        metadatumFieldsDiffSet={metadatumFieldsDiffSet}
        defaultFields={AccidentBenefitsSetExportShow.defaultFields}
        benefitsSetUrl="/accident_benefits"
        fieldGroups={fieldGroups}
        {...this.props}
      />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    exportPublish: state.benefitsSetsExportPublishings.create
  }
}

const mapDispatchToProps = {
  createExportPublish: publishingActions.create.main,
  resetCreateExportPublish: publishingActions.create.reset
}

export default connect(mapStateToProps, mapDispatchToProps)(AccidentBenefitsSetExportShow)
